import '@embeds/styles/globals.css';
import '@on3/ui-lib/styles/fonts.css';

import type { AppProps } from 'next/app';
import Script from 'next/script';
import { useEffect } from 'react';

export const MyApp = ({ Component, pageProps }: AppProps) => {
  const GA_ID = 'UA-193678100-21';

  const gaScript = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_ID}', { send_page_view: false });
    gtag('event', 'page_view', { page_path: window.location.pathname });
  `;

  // Send height to parent iframe
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const sendHeight = () => {
      window.top?.postMessage(
        {
          height: document.body.scrollHeight,
          location: window.location.href,
        },
        '*',
      );
    };

    sendHeight();

    const observer = new ResizeObserver(sendHeight);

    observer.observe(document.body);

    window.addEventListener('resize', sendHeight);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', sendHeight);
    };
  }, []);

  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-193678100-21"
        strategy="lazyOnload"
      />
      <Script id="google-analytics" strategy="lazyOnload">
        {gaScript}
      </Script>
      <Component {...pageProps} />
    </>
  );
};

export default MyApp;
